import Vue from 'vue'
import audioModalComponent from './template'
Vue.component('bus-stops-audio-modal', audioModalComponent)
